var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.countryId)?_c('span',{class:`country--icon--inner ${_vm.spanClass ? _vm.spanClass : ''}`},[_c('country-flag',{attrs:{"country":_vm.countryId,"size":"normal"}})],1):_c('v-icon',{class:_vm.defaultClass ? _vm.defaultClass : '',style:({color: _vm.isSelected ? '#fff':''})},[_vm._v("mdi-web")])
}
var staticRenderFns = []

export { render, staticRenderFns }